module.exports = __webpack_public_path__ + "static/media/neo.bef270c0.svg";